import { render, staticRenderFns } from "./ProductsAssigned.template.vue?vue&type=template&id=048b7a67&scoped=true&"
var script = {}
import style0 from "./ProductsAssigned.template.vue?vue&type=style&index=0&id=048b7a67&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b7a67",
  null
  
)

export default component.exports